import { AnyAction } from '@reduxjs/toolkit';
import { RaindropListFilter } from '@utils/tables/raindrop/raindropListFilter';

export enum ClaimLimitPeriod {
  RAIN_DURATION = 'Rain Duration',
  FIVE_SECONDS = '5 Seconds',
  TEN_SECONDS = '10 Seconds',
  THIRTY_SECONDS = '30 Seconds',
  ONE_MINUTE = '1 Minute',
  FIVE_MINUTES = '5 Minutes',
}

export type RaindropTableFilters = {
  _id?: string;
  name?: string;
  provider?: string;
  casinoId?: string;
  startDate?: string;
  endDate?: string;
  currency?: string;
  freebetValue?: number;
  dayBudget?: number;
  totalBudget?: number;
  claimRate?: number;
  status?: string;
  actions?: string;
};

export type FilterType = {
  key: string;
  value: string | number;
};

export interface RaindropTableInterface {
  limit: number;
  page: number;
  total: number;
  selectedFilters: RaindropListFilter;
  columnVisibility: RaindropListFilter;
  raindropTableFilters: RaindropTableFilters;
  columnVisibilityOptions: RaindropListFilter;
  isCancelRaindropModalOpen: boolean;
  selectedRaindropId: string;
  setSelectedRaindropId: (arg: string) => AnyAction;
  setIsCancelRaindropModalOpen: (arg: boolean) => AnyAction;
  setColumnVisibility: () => AnyAction;
  setLimit: (arg: number) => AnyAction;
  setPage: (arg: number) => AnyAction;
  setTotal: (arg: number) => AnyAction;
  setRaindropTableFilters: (arg: FilterType) => AnyAction;
}

export interface CreateRaindropReducerInterface {
  showCreateRaindropForm: boolean;
  showCancelRaindropForm: boolean;
  setShowCreateRaindropForm: (arg: boolean) => AnyAction;
  setShowCancelRaindropForm: (arg: boolean) => AnyAction;
}
